module.exports = {
    alerts: {
        deleteFile: "Opravdu chcete tento soubor smazat?",
        error: "Chyba",
        success: "Úspěšně",
        warning: "Upozornění",
        unknownError: "Neznámá chyba",
        fileNotFound: "Soubor nebyl nalezen!",
        fileNotUploaded: "Soubor nebyl nahrán!",
        fileNotDeleted: "Soubor nebyl smazán!",
        newAccessRequestTitle: "Nový požadavek na přístup!",
        newAccessRequestBody: "Distributor chce získat přístup k zákazníkovi"
    },
    asks: {
        warning: "Pozor",
        confirmCuttingTitle: "Poslat na porážku?Відправити на порізку?",
        confirmCuttingText: "Objednávka bude přesunuta do sekce \"Nové\" a všichni montéři obdrží oznámení.",
        confirmCuttingDoneTitle: "Dokončit řezání?",
        confirmCuttingDoneText: "Objednávce bude přidělen status \"Dokončeno\".",
        delete_status: "Opravdu chcete odstranit status uživatele?",
        confirmTakeOrder: "Opravdu chcete přijmout tuto zakázku?",
        confirmWasCutReminder: "Měníte status na 'Dokončeno', ale neklikli jste na tlačítko 'Střih rozstříhán'. Šablona nebude označena jako rozstříhaná. Přesto pokračovat?",
        deleteUser: "Opravdu chcete odstranit uživatele?",
        confirmClone: "Opravdu chcete tuto objednávku naklonovat?",
        delete_file: "Opravdu chcete odstranit soubor?",
        deleteCut: "Opravdu odstranit střih?",
        deleteNoteTitle: "Odstranit poznámku?",
        requestNoteDeletionTitle: "Odeslat žádost o odstranění?",
        requestNoteDeletionText: "Poznámka bude odstraněna po schválení administrátorem."
    },
    buttons: {
        clearFilter: "Vymazat",
        reply: "Odpovědět",
        reaction: "Reakce",
        selectPatterns:"Vyberte vzory z databáze",
        sendAccessRequest: "Odeslat žádost o přístup",
        reloadPage: "Obnovit stránku",
        recordAudioNote: "Nahrajte hlasovou zprávu",
        stopRecording: "Zastavit nahrávání",
        stop: "Zastávka",
        sendToCutting: "Odeslat na řezání",
        cuttingDone: "Střih je rozstříhaný (Dokončit)",
        imHere: "Jsem tady!",
        clearStatus: "Zrušit status",
        addStatus: "Přidat status",
        add: "Přidat",
        addClient: "Přidat klienta",
        addNote: "Přidat poznámku",
        acknowledged: "Seznámil jsem se",
        addOrder: "Přidat objednávku",
        addUser: "Přidat uživatele",
        apply: "Použít",
        cancel: "Zrušit",
        confirm: "Potvrdit",
        delete: "Smazat",
        deleteClient: "Smazat klienta",
        deleteOrder: "Smazat objednávku",
        edit: "Upravit",
        editOrder: "Upravit objednávku",
        logoutBtn: "Odhlásit se",
        show: "Zobrazit",
        hide: "Skrýt",
        send: "Odeslat",
        save: "Zapisz",
        subscribeUser: "Přihlásit k oznámením",
        takeToWork: "Převzít do práce",
        unsubcribeUser: "Odhlásit z oznámení",
        update: "Aktualizovat",
        clone: "Klonovat",
        downloadAllCuts: "Stáhnout všechny střihy",
        loading: "Načítání",
    },
    days: {
        friday: "Pátek",
        monday: "Pondělí",
        saturday: "Sobota",
        sunday: "Neděle",
        thursday: "Čtvrtek",
        tuesday: "Úterý",
        wednesday: "Středa"
    },
    errors: {
        notificationNotSupported: "Váš prohlížeč nepodporuje notifikace",
        serviceWorkerNotSupported: "Váš prohlížeč nepodporuje Service Worker",
        pushManagerNotSupported: "Váš prohlížeč nepodporuje push notifikace",
        notificationPermissionRequired: "Je vyžadováno povolení k zobrazování notifikací",
        serviceWorkerTimeout: "Časový limit Service Workeru",
        subscriptionFailed: "Nepodařilo se přihlásit k odběru",
        unsubscribeFailed: "Nepodařilo se odhlásit z odběru",
        notificationRequestPermission: "Přístup k oznámením nebyl povolen",
        subcriptionToServer: "Chyba při přihlášení k oznámením:",
        user_already_exists: "Uživatel již existuje",
        invalid_request: "Neplatný požadavek",
        user_not_found: "Uživatel nebyl nalezen",
        user_updated: "Uživatel byl úspěšně aktualizován",
        wrong_password: "Nesprávné heslo",
        invalid_data: "Neplatná data",
        access_denied: "Nemáte přístup k této funkci",
        invalid_token: "Neplatný token",
        not_found: "Záznam nebyl nalezen",
        create_failed: "Chyba při vytváření",
        update_failed: "Chyba při aktualizaci",
        delete_failed: "Chyba při mazání",
        unknown_error: "Neznámá chyba",
        order_delete_failed: "Nepodařilo se smazat objednávku!"
    },
    headings: {
        draftsmenStats: "Statistiky montérů",
        anomalousSessions: "Anomální relace (≥ 8 h)",
        completedOrders: "Dokončené objednávky",
        clientOrder: "Objednávka klienta",
        newOrders: "Nové objednávky",
        orderData: "Údaje o objednávce",
        carData: "Automobil",
        statusSection: "Stav a dostupnost šablon",
        actors: "Klient a manažer",
        ordersForPeriod: "Objednávky za období",
        ordersInProgress: "Probíhající objednávky"
    },
    labels: {
        replyPhoto: "Fotka",
        replyVideo: "Video",
        replyVoice: "Hlasová zpráva",
        replyMedia: "Média",
        replyUser: "Uživatel",
        replyTo: "Odpověď pro",
        editMessage: "Úprava zprávy",
        clientOwner: "Klient distributora",
        clientNotes: "Poznámky klienta",
        clientNote: "Poznámka klienta",
        problemPattern: "Problematický vzorec",
        problemPackaging: "Problém s balením",
        wasCut: "Šablona rozstříhána",
        hasNoPatterns: "Žádné šablony",
        patternRequestSent: "Odeslána žádost o šablony",
        noPatternsSelectStatus: "Vyberte stav nedostupnosti šablon",
        noPatternsNoneInAny: "Žádné šablony v žádné databázi",
        noPatternsNoneInOurs: "Žádné šablony v našich databázích",
        noPatternsPartial: "Šablony částečně dostupné",
        noPatternsPartialBadge: "Částečně",
        assemblyProgram: "Program sestavení",
        assemblyProgramSelect: "Vyberte program sestavení",
        assemblyProgramHint: "Můžete vybrat několik. Programy z dílů se načítají automaticky a spravují se v dílech.",
        assemblyProgramLocked: "Nastaveno u dílu — měňte v dílech",
        assembledIn: "Sestaveno v programu",
        filterNoPatternsPartial: "Šablony částečně dostupné",
        filterNoPatternsLabel: "Dostupnost šablon",
        filterAssemblyProgramAll: "Program sestavení: vše",
        filterNoPatternsAllOrders: "Šablony: všechny objednávky",
        filterNoPatternsAny: "Žádné šablony (vše)",
        manualTitle: "Zadat název ručně",
        unknown: "Neznámý",
        unknownModel: "Neznám model/rok nebo model chybí",
        pattern: "Šablona",
        files: "Soubory",
        accessTo: "Přístup k",
        created: "Vytvořeno",
        processed: "Zpracováno",
        waitingConfirmation: "Čeká na potvrzení",
        listened: "Poslechli jsme",
        audioNotes: "Hlasové zprávy",
        cutting: "Řezání",
        statusName: "Název statusu",
        statusColor: "Barva stavu",
        statusRole: "Pro jakou roli je status určen",
        setStatus: "Status",
        onlineUsers: "Kdo je online",
        addAutomatically: "Přidat automaticky",
        addCutToOrder: "Přidat střih k objednávce",
        order_deleted: "Mazání objednávky",
        toWorkPt1: "Objednávka",
        toWorkPt2: "byla přijata",
        carPhotos: "Fotky auta",
        customPeriod: "Období",
        editCut: "Upravit střih",
        filmLength: "Délka fólie",
        filmWidth: "Šířka fólie",
        filmCutsForOrder: "Střihy fólie pro objednávku",
        isActiveUser: "Uživatel je aktivní",
        orderFiles: "Soubory k objednávce",
        orders: "Objednávky",
        orderViewedBy: "Objednávku si prohlíží:",
        orderStatus: "Stav objednávky",
        orderFromDistributor: "Objednávka od distributora",
        phone: "Telefon",
        shortDescription: "Krátký popis",
        lastUpdate: "Poslední aktualizace",
        totalFilmArea: "Celková plocha fólie",
        userGroup: "Skupina uživatele",
        urgent: "Naléhavé!",
        changeHistory: "Historie změn",
        badge: "Odznak",
        translations: "Překlady",
        select_value: "Vyberte hodnotu"
    },
    log: {
        yes: "Ano",
        no: "Žádný",
        subcriptionUnsubscribe: "Přihlášení bylo zrušeno.",
        orderUrgent: "Objednávka je urgentní",
        orderNotUrgent: "Objednávka není urgentní",
        notePrefix: "Poznámka",
        noItems: "Nebylo",
        allCutsDeleted: "Všechny střihy byly smazány",
        fields: {
            title: "Název",
            description: "Poznámka",
            status: "Status",
            isUrgent: "Termín",
            clientId: "Klient",
            managerId: "Manažer",
            image: "Obrázky",
            file: "Soubory",
            cuts: "Úseky fólie k objednání",
            hasProblematicPattern: "Problém se šablonou",
            hasProblematicPackaging: "Problém s balením",
            wasCut: "Střih rozstříhán",
            wasCutBadge: "Rozstříháno",
            hasNoPatterns: "Žádné šablony",
            noPatternsType: "Stav nedostupnosti šablon",
            patternRequestSent: "Odeslána žádost o šablony",
            assemblyPrograms: "Program sestavení"
        }
    },
    units: {
        m: "m"
    },
    messages: {
        downloadingPatterns: "Nahrávání vzorů na server...",
        selectModelOrCheckUnknown: "Vyberte prosím model a rok vozu, nebo zaškrtněte políčko „Neznám model/rok“.",
        nothingFound: "Nic nebylo nalezeno",
        cutsSaving: "Ukládání střihů…",
        cutsSaved: "Střihy uloženy",
        cutsSaveError: "Střihy se nepodařilo uložit",
        anomalyExcluded: "Relace ≥ 8 h se nezapočítávají do pracovní doby",
        carChangedDeletePatterns: "Vybrali jste jiný model. Předchozí šablony budou smazány. Pokračovat?",
        accessRequestSent: "Žádost byla úspěšně odeslána! Čekejte na potvrzení.",
        requestFailed: "Chyba při odesílání dotazu",
        accessGranted: "Přístup povolen",
        accessRejected: "Žádost zamítnuta",
        noRequests: "Žádné dotazy",
        noClientNotes: "Zatím žádné poznámky",
        noteDeletionRequestSent: "Žádost o odstranění odeslána administrátorovi",
        noteDeletionRequestPending: "Žádost o odstranění této poznámky již byla odeslána",
        noteDeletionApproved: "Poznámka odstraněna",
        noteDeletionRejected: "Žádost zamítnuta",
        noNoteDeletionRequests: "Žádné žádosti o odstranění poznámek",
        noMicrophoneAccess: "Přístup k mikrofonu je zakázán",
        audioRecordTooShort: "Záznam je příliš krátký, nic nebylo nahráno.",
        orderCuttingDone: "Hotovo!",
        orderSentToCutting: "Odesláno!",
        statusUpdated: "Status aktualizován",
        statusCreated: "Status vytvořen",
        noManagersOnline: "Žádní manažeři online",
        noDraftsmenOnline: "Žádní montéři online",
        fileDeleted: "Soubor {name} byl úspěšně smazán",
        isUrgent: "Objednávka je naléhavá",
        uploadedFiles: "Soubory byly nahrány",
        uploadedImages: "Obrázky byly nahrány",
        deleteClientMsg: "Opravdu chcete smazat klienta",
        successfullyDeleteClientMsg: "Klient byl úspěšně smazán",
        errorDeleteClient: "Chyba při mazání klienta",
        clientHasOrders: "Klient má objednávky, smazání není možné!",
        cutDeleted: "Střih byl smazán",
        confirmDeleteOrderPt1: "opravdu chcete smazat objednávku",
        confirmDeleteOrderPt2: "Tím budou smazána všechna související data",
        userDeleted: "Uživatel byl úspěšně odstraněn",
        onlyImageDownload: "Lze stáhnout pouze obrázek!",
        fileTooLarge: "Velikost souboru přesahuje povolený limit",
        invalidFileType: "Neplatný typ souboru",
        confirmImageDelete: "Opravdu chcete smazat obrázek?",
        orderUpdated: "Objednávka byla úspěšně aktualizována",
        orderCloned: "Objednávka byla úspěšně naklonována",
        noChanges: "Žádné změny",
        noResults: "Nic nebylo nalezeno. Zkuste změnit dotaz.",
        firstSearchResults: "Zobrazeno prvních 50 výsledků. Pokračujte v psaní pro upřesnění...",
        selectNoPatternsStatus: "Vyberte prosím stav nedostupnosti šablon."
    },
    modal: {
        chatErrorTitle: "Chyba chatu",
        chatErrorText: "Nepodařilo se odeslat zprávu. Zdá se, že došlo k selhání připojení. Zkuste prosím stránku znovu načíst.",
        editStatus: "Upravit status",
        addStatus: "Přidat status",
        addOrder: "Přidat objednávku",
        editOrder: "Upravit objednávku",
        inactivityTitle: "Jste ještě tady?",
        inactivityText: "Zaznamenali jsme, že jste neaktivní po dobu 15 minut.",
        inactivitySubtext: "Pokud jste odešli, nastavte prosím příslušný status, aby o tom byli informováni vaši kolegové.",
    },
    months: {
        april: "Duben",
        august: "Srpen",
        december: "Prosinec",
        february: "Únor",
        january: "Leden",
        july: "Červenec",
        june: "Červen",
        march: "Březen",
        may: "Květen",
        november: "Listopad",
        october: "Říjen",
        september: "Září"
    },
    navbar: {
        draftsmenStats: "Statistiky montérů",
        adminPanel: "Administrace",
        allOrderList: "Seznam všech objednávek",
        mainPage: "Domů",
        myClients: "Moji klienti"
    },
    placeholders: {
        selectDraftsman: "Hledat montéra",
        search: "Hledat...",
        selectBrand: "Vyberte značku",
        selectModel: "Vyberte model",
        selectYear: "Vyberte rok",
        recordingInProgress: "Probíhá nahrávání...",
        DraftsManName: "Jméno kresliče",
        carBrandModel: "Značka a model auta",
        clientName: "Jméno klienta",
        clientPhone: "Telefon klienta",
        clientStatus: "Stav klienta",
        clientNote: "Např.: Vždy bez blinkrů",
        managerName: "Jméno manažera",
        orderDescription: "Popis objednávky",
        searchClientByName: "Hledat klienta podle jména",
        searchUserByName: "Hledat uživatele podle jména",
        selectClient: "Vyberte klienta",
        selectFiles: "Vyberte soubor",
        selectManager: "Vyberte manažera",
        userLogin: "Přihlašovací jméno",
        userPassword: "Heslo uživatele",
        writeMessage: "Napište zprávu..."
    },
    ranges: {
        last7: "Posledních 7 dní",
        thisMonth: "Za tento měsíc",
        lastMonth: "Za poslední měsíc",
        thisYear: "Za tento rok",
        allTime: "Celá doba",
        today: "Dnes",
        yesterday: "Včera"
    },
    tableheadings: {
        completedOrders: "Vyřízeno",
        totalTime: "Pracovní doba",
        reprocessedOrders: "Předělávky",
        anomalies: "Anomálie",
        reprocessTime: "Čas předělávky",
        averageTime: "Průměrný čas",
        longestTime: "Nejdelší čas",
        requests: "Dotazy distributorů",
        noteDeletionRequests: "Mazání poznámek",
        noteDeletionHistory: "Historie smazaných poznámek",
        badges: "Odznaky",
        actions: "Akce se statusem",
        color: "Barva",
        role: "Role",
        statuses: "Seznam stavů",
        draftsman: "Kreslič",
        distributor: "Distributor",
        added: "Přidáno",
        client: "Klient",
        clients: "Klienti",
        closed: "Uzavřeno",
        completed: "Dokončeno",
        created: "Vytvořeno",
        date: "Datum",
        edited: "Upraveno",
        history: "Historie",
        manager: "Manažer",
        name: "Jméno",
        note: "Poznámka",
        notes: "Poznámky",
        status: "Stav",
        title: "Název",
        type: "Typ",
        user: "Uživatel",
        users: "Uživatelé",
        all: "Vše",
        preview: "Náhled",
        table_actions: "Akce"
    },
    titles: {
        printImage: "Vytisknout obrázek",
        attentionNotes: "Pozor! Zde jsou poznámky",
        mainNote: "Hlavní poznámka"
    },
    statuses: {
        cutting: "Řezání vzoru",
        active: "Nová objednávka",
        closed: "Uzavřeno",
        done: "Dokončeno",
        work: "Probíhá",
        pending: "Očekává se",
        approved: "Schváleno",
        rejected: "Zamítnuto"
    },
    auth: {
        loginLabel: "Vaše přihlašovací jméno",
        loginRequired: "Zadejte přihlašovací jméno",
        passwordLabel: "Heslo",
        passwordPlaceholder: "Zadejte heslo",
        loginButton: "Přihlásit se",
        loginNote: "Přihlašovací údaje získáte od administrátora",
        registerTitle: "Registrace do systému",
        yourLoginLabel: "Vaše přihlašovací jméno",
        usernamePlaceholder: "Vytvořte přihlašovací jméno",
        yourPasswordLabel: "Vaše heslo",
        passwordCreatePlaceholder: "Vytvořte heslo",
        passwordConfirmLabel: "Potvrďte heslo",
        passwordConfirmPlaceholder: "Zopakujte heslo",
        registerButton: "Registrovat"
    },
    notifications: {
        order: "Objednávka",
        draftsman: "Kreslič",
        client: "Klient",
        manager: "Manažer",
        audioMessage: "Hlasová zpráva",
        defaultTitle: "Oznámení",
        testTitle: "Test oznámení",
        testText: "Test zprávy!!!",
        newOrder: "Nová objednávka",
        assignedToOrder: "Byli jste přiřazeni k objednávce",
        takenToWork: "Objednávka převzata",
        orderDone: "Objednávka dokončena",
        chatMessage: "Nová zpráva v chatu",
        reminder: "Máte neuzavřené objednávky. Změňte jejich stav"
    },
    operations: {
        create: "Vytvořit",
        update: "Aktualizovat",
        delete: "Smazat",
        get: "Získat",
        getByType: "Získat podle typu",
        getByDate: "Získat podle data",
        login: "Přihlásit se",
        logout: "Odhlásit se",
        upload: "Nahrát soubor",
        get_order: "Získat data objednávky",
        edit_order: "Upravit údaje objednávky",
        error: "Chyba v systému",
    },
    time: {
        hours_short: "hod.",
        minutes_short: "min",
        seconds_short: "sek.",
        minutes: "před několika minutami",
        minute: "před minutou",
        hours: "před několika hodinami",
        hour: "před hodinou",
        days: "před několika dny",
        day: "včera",
        weeks: "před několika týdny",
        week: "před týdnem",
        months: "před několika měsíci",
        month: "před měsícem"
    },
    logwords: {
        car: "Auto",
        carBrand: "Značka auta",
        carModel: "Model auta",
        carYear: "Rok výroby auta",
        user: "uživatel",
        order: "objednávka",
        client: "klient",
        current: "Obrázky, které již byly",
        file: "soubor",
        file_added: "Soubor přidán",
        was: "Bylo:",
        became: "Stalo se:",
        deleted: "Smazáno",
        added: "Přidáno",
        existed: "Byly fotky"
    },
    common: {
        crud: {
            titles: {
                list: 'Seznam {name}',
                create: 'Vytvořit {name}',
                edit: 'Upravit {name}',
                view: 'Zobrazit {name}'
            }
        },

        created_success: '{name} byl úspěšně vytvořen.',
        created_error: 'Chyba při vytváření {name}.',

        updated_success: '{name} byl úspěšně aktualizován.',
        updated_error: 'Chyba při aktualizaci {name}.',

        confirm_delete: 'Opravdu chcete smazat {name}?',
        deleted_success: '{name} byl úspěšně odstraněn.',
        deleted_error: 'Chyba při odstraňování {name}.',

        load_error: 'Chyba při načítání {name}.'
    },
    validation: {
        required: 'Pole {field} je povinné.',
        email: 'Zadejte platný email.',
        min: 'Minimální délka pole {field} je {min} znaků.',
        max: 'Maximální délka pole {field} je {max} znaků.',
        min_value: 'Hodnota pole {field} nesmí být menší než {min}.',
        max_value: 'Hodnota pole {field} nesmí být větší než {max}.',
        confirmed: 'Potvrzení pole {field} nesouhlasí.',
        numeric: 'Pole {field} musí obsahovat pouze čísla.',
        string: 'Pole {field} musí být text.',
        boolean: 'Pole {field} musí být true nebo false.',
        array: '{field} musí být pole.',
        integer: 'Pole {field} musí být celé číslo.',
        date: 'Pole {field} musí být platné datum.',
        url: 'Pole {field} musí být platné URL.',
        unique: 'Pole {field} musí být jedinečné.',
        exists: 'Vybraná hodnota pro {field} je neplatná.',
        digits: 'Pole {field} musí obsahovat {digits} číslic.',
        regex: 'Pole {field} má neplatný formát.',
        phone: 'Zadejte platné telefonní číslo.',
        same: 'Pole {field} a {other} se musí shodovat.',
        in: 'Neplatná hodnota pro {field}.',
        not_in: 'Hodnota pole {field} není povolena.',
        between: 'Pole {field} musí být mezi {min} a {max}.',
        file: 'Pole {field} musí být soubor.',
        mimes: 'Soubor v poli {field} musí být typu: {types}.',
        size: 'Velikost souboru v poli {field} nesmí být větší než {size} KB.'
    },
    table: {
        placeholders: {
            search: "Szukaj...",
            empty_heading: 'Data ještě nebyla přidána.',
            empty_description: 'Jakmile budou data přidána, budou zde zobrazena!'
        }
    },
    patterns: {
        cutId: "ID šablony:",
        meter: "Metr",
        "databaseTitle": "Databáze šablon",
        "searching": "Hledáme odpovídající šablony...",
        "openOnWebsite": "Otevřít \"{brand} {model}\" na webu šablon",
        "notFound": "Bohužel, pro tento model a rok nebyly nalezeny žádné šablony.",
        "viewPatterns": "Zobrazit šablony",
        "openOnSite": "Otevřít na webu",
        "backToCars": "Zpět na seznam aut",
        "addedToCuts": "Tato šablona byla přidána k odřezkům"
    }
};